<template>
  <v-dialog v-model="dialog" persistent width="600" height="300">
    <v-card>
      <v-card-title>Insira a planilha de consolidação de resultados</v-card-title>
      <v-card-text>
        <v-row v-if="isAdmin">
          <v-col>
            <v-form>
              <v-file-input
                label="Arquivo de consolidação de resultados"
                v-model="paymentFile"
                :disabled="sending || sent"
              ></v-file-input>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="sending"
          elevation="0"
          color="red"
          dark
          @click="close"
        >
          Fechar
        </v-btn>
        <v-btn
          :disabled="sending || sent"
          elevation="0"
          color="primary"
          @click="setConsolida"
        >
          Cadastrar
        </v-btn>
      </v-card-actions>
    </v-card>
    <LoadingDialog :loading="loading" />
  </v-dialog>
</template>

<script>
import {app} from "../services/feathers";
import { mapGetters } from "vuex";
import LoadingDialog from "./LoadingDialog.vue";
export default {
  props: ["dialog", "ps"],
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "isAdmin", "isStaff"]),
  },
  data() {
    return {
      paymentFile: undefined,
      sending: false,
      sent: false,
      loading: false,
      notFound: [],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async setConsolida() {
      this.loading = true;
      let id_ps = undefined;
      if (this.ps?._id) id_ps = this.ps?._id;
      if (id_ps) {
        try {
          const formData = new FormData();
          formData.append("id_ps", id_ps);
          formData.append("file", this.paymentFile);
          formData.append("avaliation_item", "Prova Escrita");
          formData.append("campo", "Situação");
          const result = await app.service("consolida-resultado").create(formData);
          this.notFound = result.notFound;
        } catch (error) {
          this.loading = false;
        }
      }
      this.loading = false;
    },
  },
  components: { LoadingDialog },
};
</script>

<style>
</style>